import styled from "styled-components";

// Color used for all preorder labels. Pulled into a constant so future
// theming swaps in one place.
const PREORDER_BLUE = "#1f5ea8";
// Soft tint of PREORDER_BLUE used as the boxed-callout background.
const PREORDER_BLUE_SOFT = "#e6eef7";

// Plain inline-style callout used inside containers that already provide
// their own visual frame (e.g. the NavigationCard "extraContent" slot on
// the Return Options page). Keeping it unboxed avoids nested-card visuals.
export const $PreorderCallout = styled.div`
  margin-top: 6px;
  color: ${PREORDER_BLUE};
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;

  .preorder-text strong {
    font-weight: 700;
  }
`;

// Boxed callout used as a standalone notice (e.g. above the Select button
// on the Exchange modal).
export const $PreorderBoxedCallout = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin-top: 12px;
  margin-bottom: 16px;
  padding: 12px 14px;
  background-color: ${PREORDER_BLUE_SOFT};
  border-radius: 8px;
  color: ${PREORDER_BLUE};
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;

  .preorder-icon {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    height: 20px;

    svg path {
      fill: ${PREORDER_BLUE};
    }
  }

  .preorder-text {
    flex: 1 1 auto;
  }

  .preorder-text strong {
    font-weight: 700;
  }
`;

// Inline variant reads as a secondary annotation next to the price (used on
// Return Preview and Return Status), so it's rendered in muted grey rather
// than the bolder preorder blue used on the standalone callout variants.
export const $PreorderInline = styled.span`
  margin-left: 6px;
  font-size: inherit;
  font-weight: 500;
`;
